import '../newstyle/css/agbook.scss'
import '../newstyle/images/agbook-logo-mobile.png'
